import React from 'react';
import { Paper } from '@material-ui/core';
import ProjectTabs from '../ProjectTabs';
import { useStyles } from './Styles';

const CollapseProjectDetails = (props) => {
  const classes = useStyles();

  const {
    open,
    stickyTabs = false, // Pin the tab strip while the expanded view scrolls
    scrollRegionHeight = null, // Height of the expanded view's scroll region (sizes the tab table)
    stickyTopOffset = 0, // Height of the pinned project row above the tab strip
    row,
    handleRefresh,
    openedProjectTab,
    handleOpenProjectTab, 
    projectColumnConfig,
    featuresAccess = {}, // Feature access object for filtering actions
    showActionsColumn = false, // Whether to show actions column in tables
    onActionClick = null, // Optional callback when action is clicked
    batchId = null, // Batch ID for batch-level tabs (required)
    collabrixCampaignID = null, // Selected campaign's collabrix ID (authoritative)
    operation = 'All', // Operation filter (default: "All")
    viewType = "systemView", // View type from FilterBar
    showChatBox = false, // Chat box state from FilterBar
    showMessages = false, // Messages state from FilterBar
    initialTabName = null, // One-shot tab to auto-select by name (e.g. "Deviations")
    onInitialTabConsumed = null, // Called once ProjectTabs applies initialTabName
    onViewTypeChange = null, // View type change handler
    onMessagesClick = null, // Messages click handler
    onChatClick = null, // Chat click handler
    onBackToTabs = null, // Back to tabs handler
  } = props;

  if (!open) return null;
  
  return (
    <Paper className={classes.container}>
      <ProjectTabs
        data={row}
        stickyTabs={stickyTabs}
        scrollRegionHeight={scrollRegionHeight}
        stickyTopOffset={stickyTopOffset}
        handleRefresh={handleRefresh}
        openedProjectTab={openedProjectTab} 
        handleOpenProjectTab={handleOpenProjectTab}
        projectColumnConfig={projectColumnConfig || null}
        featuresAccess={featuresAccess}
        showActionsColumn={showActionsColumn}
        onActionClick={onActionClick}
        batchId={batchId}
        collabrixCampaignID={collabrixCampaignID}
        operation={operation}
        viewType={viewType}
        showChatBox={showChatBox}
        showMessages={showMessages}
        initialTabName={initialTabName}
        onInitialTabConsumed={onInitialTabConsumed}
        onViewTypeChange={onViewTypeChange}
        onMessagesClick={onMessagesClick}
        onChatClick={onChatClick}
        onBackToTabs={onBackToTabs}
      />
    </Paper>
  );
};

export default CollapseProjectDetails;


